export default __webpack_public_path__ + "static/media/non-active-chk.c12c1bd8.svg";